export function Label({ children, htmlFor, className = '' }) {
  return (
    <label htmlFor={htmlFor} className={`block text-sm font-medium text-text mb-1.5 ${className}`}>
      {children}
    </label>
  );
}

export function Input({ label, labelClassName = '', inputClassName = '', error, className = '', id, ...props }) {
  const inputId = id || props.name;
  return (
    <div className={className}>
      {label && (
        <Label htmlFor={inputId} className={labelClassName}>
          {label}
        </Label>
      )}
      <input
        id={inputId}
        className={`w-full min-h-touch rounded-lg border border-border bg-input px-3 py-2.5 text-text placeholder:text-muted focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 ${inputClassName} ${error ? 'border-danger' : ''}`}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-danger">{error}</p>}
    </div>
  );
}

export function Select({ label, error, children, className = '', id, ...props }) {
  const selectId = id || props.name;
  return (
    <div className={className}>
      {label && <Label htmlFor={selectId}>{label}</Label>}
      <select
        id={selectId}
        className={`w-full min-h-touch rounded-lg border border-border bg-input px-3 py-2.5 text-text focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 ${error ? 'border-danger' : ''}`}
        {...props}
      >
        {children}
      </select>
      {error && <p className="mt-1 text-sm text-danger">{error}</p>}
    </div>
  );
}
